export const getError = state => state.newGroup.get('error')
export const getIsSubmitting = state => state.newGroup.get('isSubmitting')
